import React from "react";

type Props = {
  width: number;
  height: number;
};

export const TopicsSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 54 54`}
    >
      <defs>
        <clipPath id="clip-path-nav-topics">
          <rect
            id="長方形_1031"
            data-name="長方形 1031"
            width="33.77"
            height="37.586"
            fill="none"
          />
        </clipPath>
      </defs>
      <g
        id="グループ_845"
        data-name="グループ 845"
        transform="translate(-1118 -7.947)"
      >
        <g
          id="Buttons_-_Symbol"
          data-name="Buttons - Symbol"
          transform="translate(1118.168 7.947)"
        >
          <rect
            id="Frame"
            width="54"
            height="54"
            transform="translate(-0.168)"
            fill="rgba(0,0,0,0)"
            opacity="0"
          />
          <g
            id="グループ_1485"
            data-name="グループ 1485"
            transform="translate(10.332 9.053)"
          >
            <g
              id="グループ_1484"
              data-name="グループ 1484"
              clipPath="url(#clip-path-nav-topics)"
            >
              <path
                id="パス_9877"
                data-name="パス 9877"
                d="M30.173,18.565a1.667,1.667,0,0,1,0-1.489l3.419-6.838a1.666,1.666,0,0,0-1.49-2.41h-4.8v6.246a1.25,1.25,0,0,1-2.5,0V6a4,4,0,0,0-4-4H6.986a.5.5,0,0,0-.5.5V21.483a.5.5,0,0,0,.5.5H19.444a1.245,1.245,0,0,1-.051,2.49H13.98v.009a3.33,3.33,0,0,0,3.331,3.33H32.1a1.666,1.666,0,0,0,1.49-2.41Z"
              />
              <path
                id="パス_9878"
                data-name="パス 9878"
                d="M2,0A2,2,0,0,0,0,2V35.586a2,2,0,0,0,4,0V2A2,2,0,0,0,2,0"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
